import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Handshake, Calendar, Users } from "lucide-react";

export default function Mediation() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/mediations").then((r) => setItems(r.data)).catch(() => {}); }, []);

    return (
        <div className="space-y-6" data-testid="mediation-page">
            <div>
                <h1 className="font-heading text-3xl font-extrabold text-nhs-ink">Mediation</h1>
                <p className="text-slate-500 mt-1">Scheduled early-stage, expert-led conflict resolution sessions.</p>
            </div>
            {items.length === 0 ? (
                <div className="bg-white rounded-lg border border-slate-200 p-12 text-center text-slate-400" data-testid="empty-mediation">
                    No mediations booked yet. Book mediation from within a support case.
                </div>
            ) : (
                <div className="grid md:grid-cols-2 gap-6">
                    {items.map((m) => (
                        <div key={m.id} className="bg-white rounded-lg border border-slate-200 shadow-sm p-6" data-testid={`mediation-${m.id}`}>
                            <div className="flex items-center justify-between">
                                <div className="h-10 w-10 rounded-lg bg-nhs-teal/10 flex items-center justify-center"><Handshake className="h-5 w-5 text-nhs-teal" /></div>
                                <Badge className="bg-nhs-teal/15 text-nhs-teal border-0 capitalize">{m.status}</Badge>
                            </div>
                            <h3 className="font-heading font-semibold text-lg text-nhs-ink mt-4">{m.title}</h3>
                            <div className="mt-3 space-y-2 text-sm text-slate-600">
                                <p className="flex items-center gap-2"><Users className="h-4 w-4 text-slate-400" /> {m.parties || "—"}</p>
                                <p className="flex items-center gap-2"><Calendar className="h-4 w-4 text-slate-400" /> {m.scheduled_at ? new Date(m.scheduled_at).toLocaleString() : "—"}</p>
                                <p className="text-slate-500">Mediator: <strong className="text-nhs-ink">{m.mediator}</strong></p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
